import classNames from 'classnames';
import { getInfoIconHtml } from '../../../../includes/assets/js/modules/dpitUtilsInc';

export default class AcfTableHtmlComps {
	classes = {
		btn_small: 'acf-icon acf-icon--s',
		btn_very_small: 'acf-icon acf-icon--xs',
		btn_very_very_small: 'acf-icon acf-icon--xxs',
		btn_add_row: 'acf-icon-plus -plus',
		btn_remove_row: 'acf-icon-minus -minus',
	};
	htmleditor = (
		'<div class="acf-table-cell-editor">'
		+ '<textarea name="acf-table-cell-editor-textarea" class="acf-table-cell-editor-textarea"></textarea>'
		+ '</div>');

	constructor(config) {
		this.config = config;
		this.htmlButtons = {
			add_row: `<a href="#" class="acf-table-add-row no-drag ${this.classes.btn_small} ${this.classes.btn_add_row}"></a>`,
			remove_row: `<a href="#" class="acf-table-remove-row ${this.classes.btn_small} ${this.classes.btn_remove_row}"></a>`,
			add_link: `<a href="#" class="acf-table-add-link no-drag ${this.classes.btn_small} ${this.classes.btn_add_row}"></a>`,
			remove_link: `<a href="#" class="acf-table-remove-link no-drag ${this.classes.btn_very_very_small} ${this.classes.btn_remove_row}"></a>`,
		};

		this.body_row = `${'<div class="acf-table-body-row">'
			+ '<div class="acf-table-body-left">'}${this.htmlButtons.add_row}<div class="acf-table-body-left-wrap">`
			+ '<div class="acf-table-body-cont"><!--ph--></div>'
			+ '<div class="acf-table-sort-row-icon"></div>'
			+ '</div>'
			+ '</div>'
			+ `<div class="acf-table-body-right">${this.htmlButtons.remove_row
			}</div>`
			+ '</div>';

		this.top_cell = '<div class="acf-table-top-cell" data-colparam=""><div class="acf-table-top-cont"><!--ph--></div>'
			+ '</div>';



		this.table = `<div class="acf-table-wrap${!$.isEmptyObject(config.text_styles) ? ' acf-table-wrap--cs dpit-scrollbar' : ''}">`
			+ '<div class="acf-table-table">'
			+ '<div class="acf-table-top-row">'
			+ '<div class="acf-table-top-left"></div>'
			+ '<div class="acf-table-top-right"></div>'
			+ '</div>'
			+ '<div class="acf-table-header-row acf-table-header-hide-off">'
			+ '<div class="acf-table-header-left">' + this.htmlButtons.add_row + '</div>'
			+ '<div class="acf-table-header-right"></div>'
			+ '</div>'
			+ '<div class="acf-table-bottom-row">'
			+ '<div class="acf-table-bottom-left"></div>'
			+ '<div class="acf-table-bottom-right"></div>'
			+ '</div>'
			+ '</div>'
			+ '</div>';

	}

	header_cell(label, extraClass, value) {
		const classes = ['acf-table-header-cell'];
		if (extraClass) classes.push(extraClass);
		return (
			`<div class="${classes.join(' ')}"${value ? ` id="acf-t-header-${value}"` : ''}>
				<div class="acf-table-header-cont" data-val="${value}">${label}</div>
			</div>`
		);
	}

	body_cell(value = '', extraClass = null, extraSettings = null, id = null, title = '') {
		let extraSettingsHtml = this.extra_data(extraSettings, true);
		const idAttrStr = id ? ' id="' + id + '"' : '';
		const classes = ['acf-table-body-cell'];
		if (extraClass) classes.push(extraClass);
		return `<div${idAttrStr} class="${classNames(classes)}" title="${title}">`
			+ `<div class="acf-table-body-cont">${value}${extraSettingsHtml}</div>`
			+ '</div>';
	}

	body_cell_link(value = '', extraClass = null, extraSettings = null, row = 0, title = '') {
		let firstLinkClass = null;
		let id = '';
		if (row === 0) {

			firstLinkClass = 'acf-table-body-cell--link-multi';
			id = 'dpit-admin-first-step-link-cell';
			const items = value.split(',').filter(i => i);

			value = '<div class="acf-table-body-cell__title">';
			value += this.config.i18n.tour_starts_at;
			value += '</div>';
			value += '<ul>';
			if (items && items.length) {
				items.forEach(item => {
					value += this.body_cell_link_sub_item(item);
				});
			}
			value += '</ul>';
			value += this.htmlButtons.add_link;
			value += '<div id="dpit-admin-step-link-cell-everywhere">';
			value += this.config.i18n.EVERYWHERE;
			value += '</div>';
		}
		if (extraClass) extraClass += ' ';
		return this.body_cell(value, classNames([extraClass, firstLinkClass]), extraSettings, id, title);
	}

	body_cell_link_sub_item(value = '') {
		return `<li class="acf-table-body-cont-li"><span>${value}</span>${this.htmlButtons.remove_link}</li>`;
	}

	body_cell_checkbox(checked = false, extraClass = null, extraSettings = null, title) {
		let extraSettingsHtml = this.extra_data(extraSettings, checked);

		const classes = ['acf-table-body-cell'];
		if (extraClass) classes.push(extraClass);
		const checkedAttr = checked ? ' checked' : '';
		return `<div class="${classes.join(' ')}" title="${title}">`
			+ '<div class="acf-table-body-cont acf-table-body-cont--checkbox">'
			+ `<input type="checkbox" class="acf-table-body-cont-sub"${checkedAttr}>`
			+ extraSettingsHtml
			+ '</div>'
			+ '</div>';
	}

	body_cell_select(options, value, extraClass, /*extraSettings = null, */title = '') {
		const classes = ['acf-table-body-cont-sub'];
		if (extraClass) classes.push(extraClass);
		return `<div class="acf-table-body-cell" title="${title}">`
			+ '<div class="acf-table-body-cont acf-table-body-cont--select">'
			+ `<select class="${classes.join(' ')}">`
			+ options.map((optionCfg) => {
				const valLabel = optionCfg.split(':');
				const val = valLabel[0];
				const label = valLabel.length > 1 ? valLabel[1] : valLabel[0];
				const selected = (val == value) ? ' selected="selected"' : '';
				return `<option value="${val}"${selected}>${label}</option>`;
			}).join('')
			+ '</select>'
			//+ this.extra_data(extraSettings, checked);
			+ '</div>'
			+ '</div>';
	}

	extra_data(extraSettings, visible) {
		let extraSettingsHtml = '';
		if (extraSettings && !jQuery.isEmptyObject(extraSettings)) {
			const esWrapperClass = classNames({
				['acf-table-cell-ec']: true,
				['acf-table-cell-ec--hidden']: !visible
			});
			extraSettingsHtml += `<div class="${esWrapperClass}">`;
			Object.keys(extraSettings).forEach(id => {
				const item = extraSettings[id];

				if (item.title) extraSettingsHtml += `<div class="acf-cell-eci-wrap" data-id="${id}">`;
				switch (item.type) {
					case 'checkbox': extraSettingsHtml += `<input type="checkbox" class="acf-table-body-cont-sub"${item.val == 1 ? ' checked' : ''}>`; break;
					case 'number':
						{
							const minAttr = item.min !== undefined && item.min !== null ? ` min="${item.min}"` : '';
							const maxAttr = item.max !== undefined && item.max !== null ? ` max="${item.max}"` : '';
							const stepAttr = item.step !== undefined && item.step !== null ? ` step="${item.step}"` : '';
							extraSettingsHtml += `<input type="number"${minAttr}${maxAttr}${stepAttr} class="acf-table-body-cont-sub" value="${item.val ?? item.def}">`;
						}
						break;
					default: extraSettingsHtml += `<input type="text" class="acf-table-body-cont-sub" value="${item.val ?? item.def}">`; break;
				}
				if (item.title) extraSettingsHtml += `<span>${item.title}</span>`;
				if (item.hint || item.title) extraSettingsHtml += getInfoIconHtml('dpit-info-icon dpit-info-icon--modal dpit-info-icon--interaction', item.hint, item.title, false);
				extraSettingsHtml += '</div>';
			});
			extraSettingsHtml += '</div>';
		}
		return extraSettingsHtml;
	}

}